import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../context";
import { request } from "../utils";

import Menu from "./menu";

const View = () => {
  const { devotional: devotion } = useContext(AppContext);
  const [menu, setMenu, refresh, setRefresh] = useState(false);

  const deleteDevotion = (id) => {
    request(`delete-devotion/${id}`)
      .then((res) => {
        alert(`Devotion ${id} deleted successfully!`);
      })
      .catch((err) => console.warn(err));
  };
  const sendDevotion = (id, is_sent) => {
    if (!is_sent) {
      request(`display-devotion/${id}`)
        .then((res) => {
          alert(`Devotion ${id} sent successfully!`);
          setRefresh(!refresh);
        })
        .catch((err) => console.warn(err));
    }
  };

  return (
    <div className="admin-wrapper">
      <div className="parent-container-view admin-parent">
        <header>
          <div className="container">
            <div className="logo">
              <img src="../asset/logo.png" alt="" />
            </div>
            <nav>
              <Link to="/panel">Panel</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/devotion">Devotions</Link>
              <Link to="/stream">Streams</Link>
              <Link to="/testimony">Testimonies</Link>
              <Link to="/announcement">Announcements</Link>
            </nav>
            <div>
              <i
                className="ri-menu-fill burger"
                onClick={() => setMenu(true)}
              ></i>
            </div>
          </div>
        </header>
        {menu && <Menu setMenu={setMenu} />}
        <div className="container">
          <h2 className="color-primary mt-40 center">All Devotions</h2>
          <div className="views mt-20">
            {devotion ? (
              devotion.map((each, id) => (
                <div className="view" key={id}>
                  <span className="block color-typo-primary">{each.title}</span>
                  {!each.is_sent && (
                    <button
                      className="block color-primary"
                      onClick={() => {
                        sendDevotion(each.id, each.is_sent);
                      }}
                    >
                      Send
                    </button>
                  )}
                  <Link
                    className=" block color-primary"
                    to={`/edit-devotion/${each.id}`}
                  >
                    Edit
                  </Link>
                  <button
                    className="block color-primary"
                    onClick={() => {
                      deleteDevotion(each.id);
                    }}
                  >
                    Delete
                  </button>
                </div>
              ))
            ) : (
              <span className="error-message">There is nothing here!</span>
            )}
          </div>
        </div>
        <footer className="mt-40">
          <div className="container">
            <div className="left">
              <span>
                Vine Branch Church Apata &copy; {new Date().getFullYear()}{" "}
              </span>
            </div>
            <div className="right">
              <span>
                Developed and Maintained by{" "}
                <a href="http://pyvot360.com">Pyvot360</a>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default View;
